module.exports = __webpack_public_path__ + "media/customizations/regencyatbabcockranch/logo-ba1c069e7a6d2a2f6740653c7526bcf3.png";